<div class="row">
    <div class="col-2"></div>
    <div class="col">
        <h1 class="w-100 border-bottom">Page Not Found</h1>
        <p>Sorry but we cannot find the page you are looking.</p>
        <p><a href="/home">Return to home page.</a></p>
    </div>
    <div class="col-2"></div>
</div>
